import {ChangeDetectionStrategy, Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ConfirmDialogDataTypeEnum, IConfirmDialogData} from '@ui/modules/confirm-dialog/confirm-dialog-data.interface';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmDialogComponent {

  ConfirmDialogDataTypeEnum = ConfirmDialogDataTypeEnum;

  constructor(
    private dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IConfirmDialogData,
  ) { }

  public onClose(): void {
    this.dialogRef.close(false);
  }

  public onSuccess(): void {
    this.dialogRef.close(true);
  }
}
